<template>
  <div class="dateSelect-box" ref="dateSelect">
    <div class="dateSelect">
      <div class="dateSelect-item" v-for="(item,index) in dataset" :key="index" @click="selectNode(index)">
        <span>{{item.slice(item.indexOf('-') + 1,item.length).replace(/-/,'/')}}</span>
        <transition name="el-zoom-in-center">
          <div class="isActivt" v-show="index == idx">{{item.slice(item.indexOf('-') + 1,item.length).replace(/-/,'/')}}</div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import BScroll from '@better-scroll/core'
export default {
  props: {
    time: {
      type: Array,
      default: () => []
    },
    idx: {
      type: Number,
      default: 0
    }
  },
  watch: {
    time() {
      let nowDate = this.formatDate(new Date())
      this.dataset = [...this.time]
      this.dataset.find((res, index) => {
        if (res == nowDate) {
          this.dataset[index] = '今天'
          return true
        }
      })
    },
    idx() {
      let dom = document.getElementsByClassName('dateSelect-item')[this.idx]
      let box = document.getElementsByClassName('dateSelect-box')[0]
      let top = dom.offsetTop * 1 + 32
      if (top < (box.offsetHeight / 2)) {
        box.scrollTop = 0
      } else {
        box.scrollTop = dom.offsetTop
      }
    }
  },
  data() {
    return {
      dataset: [],
      bscroll: '',
      erd: ''
    }
  },
  mounted() {
    this.$nextTick(() => { // 监听页面改变
      this.init()
    })
  },
  methods: {
    init(callback) {
      let _this = this
      if (!this.bscroll) {
        this.bscroll = new BScroll(this.$refs.dateSelect, {
          click: true,
          bounce: false,
          scrollbar: true,
          // preventDefault: false,
          tap: true,
          mouseWheel: true,
          startX: 0,
          startY: 0,
          probeType: 3, // listening scroll hook
          swipeBounceTime: 200
        })
        callback && callback()
      } else {
        this.pullComplate()
      }
    },
    selectNode(index) {
      this.$emit('selectNode', index)
    },
    formatDate(timestamp) {
      return dayjs(timestamp).format("YYYY-MM-DD");
    }
  }
}
</script>
<style lang="scss">
.dateSelect-box {
  width: 62px;
  height: 600px;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
}
.dateSelect {
  border-radius: 4px;
  background-color: #EEEEEE;
  width: 47px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  .dateSelect-item:nth-child(1) {
    margin-top: 0;
  }
  .dateSelect-item {
    height: 32px;
    line-height: 32px;
    width: 100%;
    text-align: center;
    position: relative;
    font-size: 12px;
    color: #646482;
    margin: 3px 0;
    cursor: pointer;

    &:hover {
      color: #509aff;
    }
  }
  .isActivt {
    color: #fff;
    position: absolute;
    left: -7.5px;
    top: 0;
    width: 62px;
    height: 32px;
    background-color: #509aff;
    z-index: 2;
    border-radius: 4px;
    box-shadow: 0px 4px 8px 0px rgba(32,32,32,0.16);
  }
}
</style>
